import React from 'react'
import { HelmetProvider } from "react-helmet-async";
import { Route, Routes, Navigate } from 'react-router-dom'
import Main from './pages/main/Main'
import Introduce from 'pages/main/Introduce'
import Career from 'pages/main/Career'
import Contact from 'pages/main/Contact'
import Solutions from 'pages/main/Solutions'

const App = () =>{

  return (
    <HelmetProvider>
        <Routes>
        <Route path="/" element={<Navigate replace to="/main" />}></Route>
        <Route path="/main" element={<Main />}></Route>
        <Route path="/introduce/:section" element={<Introduce />}></Route>
        <Route path="/solutions/:section" element={<Solutions />}></Route>
        <Route path="/career" element={<Career />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        </Routes>
    </HelmetProvider>
  );
}

export default App;
